/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import UserAvatar from "../../../../components/user/UserAvatar";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList, LinkItem } from "../../../../components/links/Links";
import { handleSignout } from "../../../../utils/Utils";
import { useHistory } from "react-router-dom";
import { Button } from "../../../../components/Component";
import { clearCompanySelection } from "../../../../utils/companyUtils";
const User = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));

  // Redirigir al login si no hay token
  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      history.push("/auth-login");
    }
  }, [history]);


  const handleLogout = async () => {
    try {
      // Limpiar selección de empresa y base de datos
      await clearCompanySelection();
    } catch (error) {
      console.error('Error clearing company selection:', error);
    } finally {
      // Limpiar datos de usuario y redirigir
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user");
      history.push("/auth-login");
    }
  };

  if (!user) return null; // No mostrar nada si no hay usuario

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar icon="user-alt" className="sm" />
          <div className="user-info d-none d-xl-block">
            <div
              className={`user-status ${
                window.location.pathname.split("/")[2] === "invest" ? "user-status-unverified" : ""
              }`}
              style={{ color: "aliceblue" }}
            >
              {window.location.pathname.split("/")[2] === "invest" ? "Unverified" : "Usuario"}
            </div>
            <div className="user-name dropdown-indicator" style={{ color: "#eff2ff" }}>
              {user?.name}
            </div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar">
              <span>{user?.name ? user.name[0] : "U"}</span>
            </div>
            <div className="user-info">
              <span className="lead-text">{user?.name}</span>
              <span className="sub-text">{user?.email || ""}</span>
            </div>
          </div>
        </div>
        <div className="dropdown-inner">
          <LinkList>
            <Button color="primary" onClick={handleLogout}>
              Cerrar sesión
            </Button>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );

};

export default User;
